import { createSelector } from 'reselect';
import omit from 'lodash/omit';
import { getQuery } from './querySelectors';
import { getSearchType } from './searchSelectors';

export const getPropertyLinkQuery = createSelector(getQuery, getSearchType, (query, searchType) => {
  const sanitizedQuery = omit(query, 'utm_campaign', 'utm_source', 'featuredPropertyId', 'featuredOfferId');
  return { ...sanitizedQuery, searchType };
});
